import template from './vaccine-list.html';
import controller from './vaccine-list.controller';

let vaccineListComponent = {
  bindings: {},
  template,
  controller
};

export default vaccineListComponent;



// WEBPACK FOOTER //
// ./client/app/components/vaccine/vaccine-list.component.js